<!--
  * name: BreadCrumb
  * description: BreadCrumb 컴포넌트
-->
<template>
  <div class="container breadcrum">
    <router-link to="/" class="breadcrum-firstLink">Home</router-link>
    <span class="breadcrum-slash">/</span>
    {{ location }}
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  props: {
    location: { // 현재 위치
      type: String,
      required: true,
    },
  },
};
</script>

<style></style>
